import { Box, Grid } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../../../../../../../../../theme"
import { NonEditableTextField } from "../../../../../../../../../../../components/inputs/text-input/NonEditableTextField"
import { BSMorphology } from "../../../../../../../../../../../core/dto/beem-shot/BSMorphology/BSMorphology"
import { BSMorphologyEnum, bsMorphologyLabelEnum } from "../../../../../../../../../../../core/enum/bsMorphologyEnum"

interface IProps {
  morphology: BSMorphology
}

export function NonEditableLevelMorphology({ morphology }: Readonly<IProps>): React.JSX.Element {
  return (
    <Grid item xs={6}>
      <NonEditableTextField
        label="Forme du bâtiment"
        value={bsMorphologyLabelEnum[morphology.shape]}
        backgroundColor={customPalette.lightGray5}
      />

      {morphology.shape === BSMorphologyEnum.RECTANGLE && (
        <Box display="flex" gap={2}>
          <NonEditableTextField
            label="Dimension 1"
            value={morphology.rectangleDimension.dimensionRectangle1}
            backgroundColor={customPalette.lightGray5}
          />

          <NonEditableTextField
            label="Dimension 2"
            value={morphology.rectangleDimension.dimensionRectangle2}
            backgroundColor={customPalette.lightGray5}
          />
        </Box>
      )}

      {morphology.shape === BSMorphologyEnum.L && (
        <>
          <Box display="flex" gap={2}>
            <NonEditableTextField
              label="Dimension 1"
              value={morphology.shapeLDimension.dimensionL1}
              backgroundColor={customPalette.lightGray5}
            />

            <NonEditableTextField
              label="Dimension 2"
              value={morphology.shapeLDimension.dimensionL2}
              backgroundColor={customPalette.lightGray5}
            />
          </Box>

          <Box display="flex" gap={2}>
            <NonEditableTextField
              label="Dimension 3"
              value={morphology.shapeLDimension.dimensionL3}
              backgroundColor={customPalette.lightGray5}
            />

            <NonEditableTextField
              label="Dimension 4"
              value={morphology.shapeLDimension.dimensionL4}
              backgroundColor={customPalette.lightGray5}
            />
          </Box>
        </>
      )}
    </Grid>
  )
}
